var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMidi = function SvgMidi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#1C7ABE",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.642 13.5h1.043l1.101 2.688h.047L7.935 13.5h1.042v4h-.82v-2.604h-.033L7.089 17.48H6.53l-1.035-2.593h-.033V17.5h-.82zm6.043 0v4h-.846v-4zm2.279 4h-1.418v-4h1.43q.603 0 1.038.24t.67.686q.237.447.237 1.07 0 .626-.237 1.074-.234.45-.673.69-.438.24-1.047.24m-.572-.725h.537q.375 0 .63-.132.258-.135.387-.416.13-.285.131-.73 0-.444-.13-.726a.85.85 0 0 0-.386-.414 1.36 1.36 0 0 0-.63-.132h-.54zm4.166-3.275v4h-.846v-4z"
  })));
};
export default SvgMidi;